<template>
  <a-dialog v-model="show" width="60vw" max-width="90vw" persistent scrollable>
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <v-tooltip bottom :disabled="!isEllipsis(title, 80)">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="display: inline-block">
                    {{ ellipsis(title, 80) }}
                  </div>
                </template>
                <span v-text="title"></span>
              </v-tooltip>
          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>
      </v-banner>
      <v-card-text
        style="color: black; min-height: 300px"
        v-if="getMeetingChats.length > 0"
        ref="scrollToMe"
      >
         <v-timeline :dense="$vuetify.breakpoint.smAndDown">
          <v-timeline-item
            v-for="comment in getMeetingChats"
            :key="`comment-timeline-${comment.id}`"
          >
            <span slot="opposite"
              ><span
                style="font-size: 18px !important"
                :class="`title font-weight-bold pageHeader--text`"
                >{{ commentDate(comment.created_at) }}</span
              ></span
            >
            <chat-timeline-card
              :comment="comment"
              @editComment="editComment"
            ></chat-timeline-card>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      <v-card-text
        class="text-h6"
        style="color: black; text-align: center"
        v-else
      >
        {{ $t("agenda.hRecordNotFound") }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom >
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              class="mr-2"
              color="primaryDark"
              small
              v-bind="attrs"
              v-on="on"
              @click="createComment"
              ><span>{{ $t("chat.lblAddMessage") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("chat.lblAddMessage") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              color="secondary"
              small
              @click="close()"
              v-bind="attrs"
              v-on="on"
              ><span>{{ $t("btnClose") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnClose") }} </span>
        </v-tooltip>
      </v-card-actions>
      <chat-form
        v-if="commentDialog"
        v-model="commentDialog"
        :meetingObject="meetingObject"
        :commentData="comment"
        @saveComment="saveComment"
        :chatId="chatId"
      ></chat-form>
      <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></MessageSheet>
    </v-card>
  </a-dialog>
</template>

<script>
import ChatTimelineCard from "./ChatTimelineCard.vue";
import ChatForm from "./ChatForm.vue";
import { mapGetters, mapState, mapActions } from "vuex";
import { formatDate } from "../../../utils/util";
import SignalRMixin from "../../../mixin/SignalRMixin";
import Loader from "@/components/Loader.vue";
import MessageSheet from "@/components/MessageSheet.vue";

export default {
  name: "ChatTimelineBox",
  mixins: [SignalRMixin],
  components: {
    ChatTimelineCard,
    ChatForm,
    Loader,
    MessageSheet,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    chatId: {
      type: String,
      required: true,
    },
    meetingObject: {
      type: Object,
      default: true,
    },
  },
  data() {
    return {
      commentDialog: false,
      comment: null,
      displayMessage: false,
      message: "",
      messageType: "",
    };
  },
  
  computed: {
    ...mapState({
      meetingChatComments: (state) => state.agenda.meetingChatComments,
      agendaMeetingChatLists: (state) => state.agenda.agendaMeetingChatLists,
    }),
    title(){
      const index = this.agendaMeetingChatLists.findIndex(mchat => mchat.id === this.chatId);
      const chatdata = this.agendaMeetingChatLists[index]
      return (chatdata && chatdata.title) ? `${this.$t("chat.lblChat")} #${index + 1} - ${chatdata.title}` : `${this.$t("chat.lblChat")} #${index + 1}`
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    commentDateFormat() {
      return this.selectedLang !== "ja"
        ? "yyyy/MM/dd HH:mm"
        : "yyyy/MM/dd HH:mm";
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    getMeetingChats(){
      return this.meetingChatComments ? this.meetingChatComments.comments : []
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
  },
  async mounted() {
    const target = "chat_message_add_" + this.chatId;
    await this.signalRInit(target); 
    const targetUpdate = "chat_message_update_" + this.chatId;
    await this.signalRInit(targetUpdate); 
    const targetDelete = "chat_message_delete_" + this.chatId;
    await this.signalRInit(targetDelete); 
  },
  methods: {
    ...mapActions({
      listMeetingChatComments: "agenda/listMeetingChatComments",
    }),
    scrollToElement() {
    const el = this.$refs.scrollToMe;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    commentDate(commentdate) {
      return formatDate(new Date(commentdate), this.commentDateFormat);
    },
    close() {
      this.$emit("input", false);
      this.comment = null;
    },
    createComment() {
      this.comment = null;
      this.commentDialog = true;
    },
    editComment(comment) {
      this.comment = comment;
      this.commentDialog = true;
    },
    saveComment(response) {
      if(response.requestType == "add"){
        this.scrollToElement()
      }
      
      if (response.status) {
        this.showMessageSheet(this.$t("chat.msgChatSaveSuccess"), "success");
      } else {
        this.showMessageSheet(this.$t("chat.msgChatFaild"), "error");
      }
      this.commentDialog = false;
    },
    async signalRInit(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          await this.listMeetingChatComments(this.chatId);
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        console.error(error);
      }
    },
    isEllipsis(string, length) {
      return String(string).length > length;
    },
    ellipsis(string, length) {
      return this.isEllipsis(string, length)
        ? string.substring(0, length) + "..."
        : string;
    },
  },
};
</script>
